import React from "react";
import "./App.css";
import Cart from "./Components/Cart/Cart";

function App() {
  return (
    <>
      <Cart />
    </>
  );
}
export default App;
